export default [
  {
    path: '/system-service-setting',
    name: 'system-service-setting',
    component: () => import('@/views/serviceSystemSetting/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.serviceSystemSetting',
      navActiveLink: 'service-system-setting',
      resource: 'service-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.serviceSystemSetting',
          active: true,
        },
      ],
    },
  },
]
